import { PrecisionFloat } from '@bts-web/utils-formatting';
import { Locale } from '@bts-web/utils-lokalise';
import {
  MaximumTradeAmountType,
  MinimumTradeAmountType,
  MutableNonNullableAsset,
  TradeInnerTranslatedValues,
} from '../types';
import { type AmountQuickSelectItem } from '../../../common';
import { TradeControllerVariants, TradeScreenTranslations } from '../../utils';
import { OrderOperation } from '../../../orders/types';
import { SavingsPlanFrequency } from '@bts-web/data-layer/server';

export interface TradeAssetDetails {
  price: PrecisionFloat;
  assetType: MutableNonNullableAsset['__typename'];
  symbol: MutableNonNullableAsset['symbol'];
  id: MutableNonNullableAsset['id'];
  name: MutableNonNullableAsset['name'];
  logoUrl: MutableNonNullableAsset['logoUrl'];
  assetIsNotTradeable: boolean;
  portfolio: MutableNonNullableAsset['portfolio'];
  __typename: MutableNonNullableAsset['__typename'];
}

export interface TradeFormProps {
  locale: Locale;
  isDataLoading: boolean;
  currentTradeDetails: {
    maximumTradeAmount: MaximumTradeAmountType;
    minimumTradeAmount: MinimumTradeAmountType;
    quickSelectTradeItems: AmountQuickSelectItem[];
    userCannotTrade: boolean;
    swapExchangeRate?: PrecisionFloat;
  };
  targetAssetData?: MutableNonNullableAsset;
  overrideOperationWithVariant?: TradeControllerVariants;
  assetDetails: TradeAssetDetails;
  staticValues: {
    translatedValues: TradeInnerTranslatedValues;
    transactionType: TradeControllerVariants;
    orderOperation?: OrderOperation;
    currentLocale: Locale;
    currency: string;
    translations: TradeScreenTranslations;
  };
  openBuyTab?: () => void;
}

export const SP_WEEKLY_FREQUENCY: SavingsPlanFrequency = 'WEEKLY';

export const SP_BIWEEKLY_FREQUENCY: SavingsPlanFrequency = 'BIWEEKLY';

export const SP_MONTHLY_FREQUENCY: SavingsPlanFrequency = 'MONTHLY';

export const SP_DAILY_FREQUENCY: SavingsPlanFrequency = 'DAILY';
